/** Inbox thread-view (chat log) strings, split out of enInbox. */
export const enInboxThread = {
	showFullMessage: "Show full message",
	showLess: "Show less",
	showTrimmedContent: "Show trimmed content",
	hideTrimmedContent: "Hide trimmed content",
	linkedinInviteAccepted: "Accepted your LinkedIn invite",
	inmailSent: "sent an InMail",
	inmailSentManually: "sent an InMail manually",
	otherAccountConversation_one: "Also in contact: {{name}} · {{count}} message",
	otherAccountConversation_other: "Also in contact: {{name}} · {{count}} messages",
	// PREC-4305: the lead's history on the viewer's own LinkedIn and mailboxes, pulled on demand.
	earlierConversation: {
		load: "Load earlier conversation",
		loading: "Loading earlier conversation…",
		imported: "Imported",
		importedByYou: "Imported by you",
		importedBy: "Imported by {{name}}",
		importedHintShared:
			"Imported from the importer's own LinkedIn or mailbox. Shared with your team. History only: it changes no status, count or sequence.",
		importedHintPrivate:
			"Imported on a private lead from your own LinkedIn or mailbox. Only you can see it. History only: it changes no status, count or sequence.",
		sharedNote: "What you load here is shared with your team",
		privateNote: "Private lead: what you load here is only visible to you",
		requestFailed: "Could not load the earlier conversation. Try again in a moment.",
		truncated: "Showing the latest {{count}} imported messages",
		linkedin: {
			IMPORTED_one: "{{count}} earlier message added from your LinkedIn",
			IMPORTED_other: "{{count}} earlier messages added from your LinkedIn",
			UP_TO_DATE: "Your LinkedIn conversation with this lead is already in the chat",
			NOTHING_FOUND: "No earlier conversation found on your LinkedIn",
			NOT_CONNECTED: "Your LinkedIn account is not connected, so it was not searched",
			NO_LEAD_IDENTITY: "This lead has no LinkedIn profile to look up",
			FAILED: "Could not read your LinkedIn. Try again in a moment.",
			BLOCKED: "Reading LinkedIn is switched off in this environment",
		},
		email: {
			IMPORTED_one: "{{count}} earlier email added from your mailbox",
			IMPORTED_other: "{{count}} earlier emails added from your mailbox",
			UP_TO_DATE: "Your emails with this lead are already in the chat",
			NOTHING_FOUND: "No earlier conversation found in your mailbox",
			NOT_CONNECTED: "You have no connected mailbox, so none was searched",
			NO_LEAD_IDENTITY: "This lead has no email address to look up",
			FAILED: "Could not read all of your mailboxes. Try again in a moment.",
			BLOCKED: "Reading mailboxes is switched off in this environment",
		},
	},
	nav: {
		top: "Top",
		previous: "Previous",
		next: "Next",
		replyDraft: "Reply draft",
	},
	wrongPerson: {
		reachOutTo: "Reach out to {{name}}",
		findSomeoneIn: "Find someone in {{department}}",
		findAnotherContact: "Find another contact",
		nameFilterLabel: "Name",
		footerNotePerson:
			"Searching for “{{name}}” — the person named in the reply · adjust filters, then click Search",
		footerNoteDepartment:
			"Filters pre-filled from the reply ({{department}}) · adjust filters, then click Search",
		footerNoteGeneric:
			"Filters pre-filled from the lead's company · adjust filters, then click Search",
		addToOutreach: "Add to outreach",
	},
	// PREC-5088: a rejected list request says so instead of leaving an empty list on screen.
	loadError: {
		title: "Could not load the leads",
		hint: "Something went wrong while loading this list. Change a filter or reload the page to try again.",
	},
};
